import Footer from "../../component/footer";
import Intro from "../../component/Intro";
import ServicesSection from "../../component/service-comp/Services";
import Smgallary from "../../component/Smgallary";

// eslint-disable-next-line react/prop-types
function Home({ setmymode, mode }) {
  const textinline = {
    headh1: "welcome to",
    spano: "SIRIUS",
    subh1:
      "Your Digital Solution Partner, We turn ideas into extraordinary digital products.",
    paragraph1:
      "Your premier digital agency for cutting-edge web development and online solutions. We are here to help you achieve your digital goals with expertise and innovation.",
  };
  
  return (
    <div style={{
      overflowX: 'hidden',
    
        }}>
      <Intro mode={mode} setmymode={setmymode} textinline={textinline} />
      <ServicesSection />
      <Smgallary />
      <Footer />
    </div>
  );
}

export default Home;
